import {PartialFeature} from '../feature-view';

/** колонки ячеек заклинаний называются кругом: `@1`, `@2`, … */
export const SPELL_LEVELS_REGEXP = /@\d/;

const COLUMN_TITLES: Record<string, string> = {
	'@ProficiencyBonus': 'Бонус умения',
	'@Features': 'Особенности',
	'@Cantrips': 'Фокусы',
	'@PreparedSpells': 'Закли­нания',
	'@Level': 'Уро­вень',
	'@WeaponMastery': 'Оружейное мастерство',
};

export function columnTitle(column: string) {
	return COLUMN_TITLES[column] || column;
}

export function levelFeatures(features: PartialFeature[], level: string) {
	return features?.filter((feature) => feature.levels?.includes(level) && !feature.parentId) || [];
}

/** у особенности бывает своё название на каждом уровне, где она получена */
export function featureTitle(feature: PartialFeature, level: string) {
	const index = feature.levels ? feature.levels.findIndex((l) => l === level) : -1;
	return (feature.levelTitles && index > -1 && feature.levelTitles[index]) || feature.title;
}
